export default "__VITE_ASSET__BEKPyIsd__"